import React, { useState } from 'react';
import {  VulnerabilityOptionsCarLoan } from '../../../../Constants/Constants';


const FollowingApply = ({ onNext, answers, stepKey }) => {
  const [error, setError] = useState('');
  const [selection, setSelection] = useState(answers[stepKey] || []);

  const handleSelection = (key) => {
    setError('');
    let newSelection = [...selection];
    
    if (selection.includes(key)) {
      newSelection = newSelection.filter(item => item !== key);
    } else {
      newSelection.push(key);
    }
    setSelection(newSelection);
  };

  const handleContinue = () => {
    console.log('Selected Vulnerability Options:', selection);
    if (selection.length === 0) {
      setError('Please select at least one option.');
      return;
    }
    setError('');
    onNext(selection);
  };

  return (
    <>
      <div className="qs-card__head">
        <h2 className="qs-card__title">In the time leading up to or during the car loan, did any of the following apply to you?</h2>
        <p className="qs-card__sub">Tick all that apply</p>
      </div>
      <div className="qs-card__body">
        <ul className="qs-list js-multi">
          {Object.entries( VulnerabilityOptionsCarLoan).map(([key, value]) => (
            <li key={key}>
              <button 
                className={`qs-check qs-check--left ${selection.includes(key) ? 'is-on' : ''}`} 
                onClick={() => handleSelection(key)}>
                  {value}
              </button>
            </li>
          ))}
        </ul>
        {error && <p className="qs-error-message" style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        <div className="qs-actions">
            <button type="button" className="qs-btn qs-btn--primary" onClick={handleContinue} data-quest-id="156">Submit <span className="qs-arrow">→</span></button>
        </div>
      </div>
    </>
  );
};

export default FollowingApply;
